import DraggableModifier from './draggable';
export default class SortableItemModifier extends DraggableModifier {
  attach() {
    super.attach();
    this.draggableElement.dataset.flySortableGroupName = this.groupName;
  }
  get context() {
    return {
      ...this.named.context,
      item: this.item
    };
  }
  get item() {
    return this.named.item;
  }
  get groupName() {
    return this.named.groupName ?? '';
  }
}